import {BaseCardScratchpadState} from '../../scratchpad/baseCardScratchpad.types';
import {NodeType} from 'common/src/modules/nodes/nodes.types';
import {cardTypeToName} from 'common/src/modules/campaigns/copilot/agents/campaignSetupAgent/campaignSetupAgent.config';

export default function validateAgentScratchpad<TCardState extends BaseCardScratchpadState>(
  agentScratchpad: BaseCardScratchpadState,
  cardType?: NodeType,
): TCardState {
  if (!agentScratchpad) {
    throw new Error('Agent scratchpad is required for this tool');
  }

  if (!agentScratchpad.card) {
    throw new Error('Card was not found in state');
  }

  if (cardType && agentScratchpad.card.type !== cardType) {
    throw new Error(`Card is not a ${cardTypeToName[cardType]} card`);
  }

  return agentScratchpad as TCardState;
}
